import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import { useGetInfringementBadgeQuery } from 'src/context/api/brandInfringement/api';

export default function BrandInfringementTabLabel({ label }: { label: string }) {
    const workspace: any = useCurrentWorkspace();
    const { data } = useGetInfringementBadgeQuery(
        { workspaceTable: workspace?.bqTable },
        { skip: !workspace?.bqTable },
    );
    const count = data?.count ?? 0;
    return <>{count > 0 ? `${label} (${count})` : label}</>;
}
